export const en = {
    'campaign-group': 'Campaign/ad group',
    'campaign-type': 'Campaign type',
    name: 'Name',
    'price-context': 'CPM bid, {currency}',
    'price-context-networks': 'Bid (in ad networks), {currency}',
    'user-profile-condition': 'Impression criteria'
};
